










import { Component } from "vue-property-decorator";
import Header from "@/components/header/OLoginHeader.vue";
import FormPassEdit from "@/components/forms/FormPassEdit.vue";
import Footer from "@/components/Footer.vue";
import CheckOrganizationAdminLogin from "@/utils/CheckOrganizationAdminLogin";

@Component({
  components: {
    Header,
    FormPassEdit,
    Footer,
  },
})
export default class ORegisterPassEdit extends CheckOrganizationAdminLogin {}
